export const formatDate = (isoString: string): string => {
  if (!isoString) return "";
  const [year, month, day] = isoString.split("T")[0].split("-");
  return `${day}.${month}.${year}`;
};

export const formatDateTime = (isoString: string): string => {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2); // "yy"
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}.${month}.${year}, ${hours}:${minutes}`;
};

export const formatPeriod = (ms: number): string => {
  if (ms < 0) return "Просрочено";
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  if (days >= 365) {
    const years = Math.floor(days / 365);
    return `${years} ${declOfNum(years, ["год", "года", "лет"])}`;
  }
  if (days >= 30) {
    const months = Math.floor(days / 30);
    return `${months} ${declOfNum(months, ["месяц", "месяца", "месяцев"])}`;
  }
  if (days >= 7) {
    const weeks = Math.floor(days / 7);
    return `${weeks} ${declOfNum(weeks, ["неделя", "недели", "недель"])}`;
  }
  return `${days} ${declOfNum(days, ["день", "дня", "дней"])}`;
};

function declOfNum(n: number, titles: [string, string, string]): string {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    n % 100 > 4 && n % 100 < 20 ? 2 : cases[n % 10 < 5 ? n % 10 : 5]
  ];
}

export const toUTCStartOfDay = (date: Date | null): string | null => {
  if (!date) return null;
  const utcDate = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  return utcDate.toISOString();
};
